import React from 'react';
import styles from './../styles/dashboard.module.scss'

const DashboardHeader = (props) => {
  const { title, isLastConnection } = props;
  return (
    <header className={styles.__header}>
      <h1 className={styles.__title}>{title}</h1>
      <div style={{display: 'flex'}}>
      <button 
        className={[styles.__btn_dashboard, isLastConnection ? styles.__selected : ''].join(" ")}
        onClick={() => props.click(true)}
        >
        <span className={styles.__btn_name}>User List</span>
      </button>
      <button 
        className={[styles.__btn_dashboard, !isLastConnection ? styles.__selected : ''].join(" ")}
        onClick={() => props.click(false)}
        >
        <span className={styles.__btn_name}>User Metrics </span>
      </button>
      </div>
    </header>
  )
}

export default DashboardHeader;
